import script from "./SalaryDatatable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalaryDatatable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__